<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <h2 class="field-dialog__header__title">
        {{ 'RECURRENCES.DIALOG.TABS.TAB_LINKS.LINK.HEADER' | translate }}
      </h2>
    </div>

    <button class="field-dialog__header__close" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="field-dialog__content__scroll dialog-link" fusePerfectScrollbar>
    <div>
      <fc-outlined-input
        [prefixIcon]="'search'"
        [control]="searchControl"
        [required]="false"
        [label]="'RECURRENCES.DIALOG.TABS.TAB_LINKS.INPUT_PLACEHOLDER' | translate"
      ></fc-outlined-input>
    </div>

    <div *ngIf="isEmpty && !isLoading" class="dialog-link__empty">
      <p class="dialog-link__empty-text">
        {{ 'RECURRENCES.DIALOG.TABS.TAB_LINKS.LINK.EMPTY_DESCRIPTION' | translate }}
      </p>
    </div>

    <ng-container *ngIf="!isEmpty">
      <div class="dialog-link__header">
        <p class="dialog-link__header-title">
          {{ 'RECURRENCES.DIALOG.TABS.TAB_LINKS.LINK.TITLE' | translate }}
        </p>
        <button
          mat-button
          color="primary"
          class="dialog-link__tree__header-select"
          (click)="checkAll()"
          [disabled]="isLoading"
        >
          {{ 'RECURRENCES.DIALOG.TABS.TAB_LINKS.LINK.SELECT_ALL' | translate }}
        </button>
      </div>

      <div *ngIf="!isLoading" class="dialog-link__tree">
        <div class="dialog-link__tree__node" *ngFor="let sector of locationLinks">
          <fc-tree-view [item]="sector"></fc-tree-view>
        </div>

        <div class="dialog-link__tree__node" *ngFor="let equipment of unlinkedEquipments">
          <fc-tree-view [item]="equipment"></fc-tree-view>
        </div>
      </div>
    </ng-container>

    <div class="dialog-link__tree__skeleton" *ngIf="isLoading">
      <div class="dialog-link__tree__skeleton__node" *ngFor="let item of [].constructor(5)">
        <div>
          <ngx-skeleton-loader [theme]="{ height: '30px', margin: '0px', padding: '0px' }"></ngx-skeleton-loader>
        </div>
        <div class="dialog-link__tree__skeleton__node__items">
          <ngx-skeleton-loader
            [theme]="{ height: '30px', margin: '0px', padding: '0px' }"
            *ngFor="let subitem of [].constructor(2)"
          ></ngx-skeleton-loader>
          <div class="dialog-link__tree__skeleton__node__items dialog-link__tree__skeleton__node__items--equipments">
            <ngx-skeleton-loader [theme]="{ height: '30px', margin: '0px', padding: '0px' }"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button class="field-background" mat-raised-button (click)="save()">
      {{ 'RECURRENCES.SAVE' | translate }}
    </button>
  </div>
</div>
